import { styled } from '@grupoboticario/flora'
import { Box, BoxProps } from '@grupoboticario/flora-react'

export const ImageWrapper = styled('div', {
  cursor: 'grab',
  height: '100%',
  width: '100%',
  maxWidth: '100vw',
  position: 'relative',
})

export const Image = styled(
  ({ src, css, ...props }: BoxProps & { src: string }) => (
    <Box
      css={{
        ...css,
        backgroundColor: 'transparent',
        backgroundImage: `url(${src})`,
        backgroundRepeat: 'no-repeat',
      }}
      {...props}
    />
  ),
  {
    backgroundSize: 'contain',
    width: '100%',
  },
)

export const HiResImage = styled(Image, {
  position: 'absolute',
  left: 0,
  top: 0,
  transition: 'opacity 300ms linear',
})
